export const weekdayFromNumberToString = (weekDayAsNumber: number): string => {
  if (weekDayAsNumber < 0 || weekDayAsNumber > 6) return '';
  return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][
    weekDayAsNumber
  ];
};
export const weekdayFromStringToNumber = (weekDayAsString: string): number => {
  const weekDays: { [key: string]: number } = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  return weekDays[weekDayAsString];
};
